import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import FrequencyTable, { FREQUENCY_COLUMNS, FREQUENCY_CARDS, FREQUENCY_MIN_TABLE_WIDTH } from 'components/Tables/Frequency';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from '../bookings/bookings-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'frequencyStore') @observer
class FrequencyIndexPage extends Component {

  @observable visible = true;

  render() {
    let content;
    let {
      frequencyStore,
      frequencyStore: {
        frequencies: {
          isLoading,
          isError
        }
      },store, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={FREQUENCY_COLUMNS}
          cards={FREQUENCY_CARDS}
          minTableWidth={FREQUENCY_MIN_TABLE_WIDTH}
          noun="frequencies"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="frequencies" onRetry={() => frequencyStore.loadFrequencies()} />;
    }
    if (!isError && !isLoading) {
      content = <FrequencyTable />
    }
    return (
      <div>
        <Helmet>
          <title>Frequency | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.FrequencySearch key={viewStore.listFiltersVersion} />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default FrequencyIndexPage;